import * as React from 'react'
import { Box, Typography as MIUTypography, Button } from '@mui/material'
import { codeQrBase } from '../../config/codeQrConfig'
import { styled } from '@mui/material/styles'
import QRCodeStyling from 'qr-code-styling'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  zIndex: 0,
  fontStyle: 'normal',
  fontSize: '0.95em',
  fontWeight: 500,
  lineHeight: '24px',
  color: '#000000ab',
  '&:hover': { color: 'var(--color-green-light)', fontWeight: 650 },
}))

const CodeQrModal = ({ onClose, treeId, isAuth }) => {
  const codeQrContainer = React.useRef(null)
  const [fileExt, setFileExt] = React.useState('png')
  const background = fileExt === 'png' ? '#ffffff00' : '#ffffff'

  const qrCode = new QRCodeStyling(codeQrBase({ treeId, background }))

  const handleDownloadAction = () => qrCode.download({ name: treeId, extension: fileExt })
  const onExtensionChange = event => setFileExt(event.target.value)

  React.useEffect(
    () => qrCode.append(codeQrContainer.current), // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <Box>
      <Box sx={{ width: '100%', height: '100%', p: 1, pb: 0 }} ref={codeQrContainer} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'baseline',
          mt: '-8px',
        }}>
        {Boolean(isAuth) && (
          <Box>
            <select onChange={onExtensionChange} value={fileExt}>
              <option value="png">PNG</option>
              <option value="jpeg">JPEG</option>
              <option value="webp">WEBP</option>
            </select>
          </Box>
        )}
        <Button onClick={onClose}>
          <Typography sx={{ '&:hover': { color: 'var(--color-primary)' } }}>
            Regresar
          </Typography>
        </Button>
        {Boolean(isAuth) && (
          <Button onClick={handleDownloadAction}>
            <Typography>Descargar</Typography>
          </Button>
        )}
      </Box>
    </Box>
  )
}
export default React.memo(CodeQrModal)
